import { Component, Mixins, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import Role from '@/views/Authorization/models/role'
import Permission from '@/views/Authorization/models/permission'

import ToolbarComponent from '@/_components/bar/appToolbar/appToolbar.vue'
import RoleCheckbox from '@/views/Authorization/components/roleChkbox/roleChkbox.vue'
import ForbiddenView from '@/views/App/views/ForbiddenView/ForbiddenView.vue'
import Authorization from '@/views/Authorization/models/authorization'
import ProjectUser from '@/views/Authorization/models/projectUser'

@Component({
    components: { ToolbarComponent, RoleCheckbox, ForbiddenView },
})
export default class RolesSettings extends Mixins<MixinInterface>() {
    get allowedAccess() {
        return this.hasPermission(this.currentProjectPermissions, this.requiredPermissions)
    }

    roles: Array<Role> = []
    specialRoles: Array<Role> = []
    columns: Set<Permission | string> = new Set()
    permissions: Array<Array<Permission>> = []
    permissionGroups: Array<any> = []
    loading = true
    disabled = false
    disabledBox = false
    permissionVisibility: Record<string, boolean> = {}

    @Watch('currentProjectId', { immediate: true })
    async changeProject() {
        if (this.currentProjectId && this.allowedAccess) {
            this.loading = true
            await this.getRoles()
            if (this.currentUser) {
                await ProjectUser.getProjectUser(this.currentProjectId, this.currentUser.id, true)
            }
            if (this.permissionGroups.length == 0) {
                await this.getPermissions()
            }
            this.loading = false
        }
    }

    async getRoles() {
        if (this.currentProjectId) {
            let res = await Role.getRoles(this.currentProjectId)
            res.forEach((role) => {
                if (role.isNormal) {
                    this.roles.push(role)
                } else if (role.kind == 'guest' || role.kind == 'global') {
                    this.specialRoles.push(role)
                }
            })
        }
    }

    async getPermissions() {
        let res = await Permission.getAllPermissions()
        let visibleModules: Record<string, boolean> = {}
        this.activeModules.forEach((module: any) => {
            visibleModules[module.relationships.module.data.id] =
                module.attributes.status !== 'deleted'
        })

        let isModuleHidden = (module: string) => {
            return this.avalableModules.includes(module) && !visibleModules[module]
        }

        res.forEach((item: Permission) => {
            if (isModuleHidden(item.module)) {
                return
            }

            this.columns.add(item.module)

            if (
                (item.name === 'observation.edit_public_observations_for_employer' ||
                    item.name === 'observation.view_public_observations_for_employer') &&
                this.roles.every((role) => !role.hasPermission(item.name)) &&
                this.specialRoles.every((role) => !role.hasPermission(item.name))
            ) {
                return
            }

            if (item.name?.includes('project.manage.')) {
                let module = item.name.split('.').pop()
                if (module && !isModuleHidden(module)) {
                    this.columns.add(item)
                }
            } else {
                this.columns.add(item)
            }
        })
    }

    showAuthorizationInfo() {
        Authorization.showAuthorizationLog()
    }

    async addRole() {
        let res = await Role.addRole()
        if (res instanceof Role) {
            this.roles.push(res)
        }
    }

    async deleteRole(role: Role, index: number) {
        this.disabledBox = true
        let res = await role.removeRole(role)
        if (res) {
            this.roles.splice(index, 1)
        }
        this.disabledBox = false
    }

    moduleIsAccessible(name: string) {
        return true
        // let res = this.projectModules.find((item: any) => {
        //     return item?.attributes.isAccessible && item.relationships.module.data.id == name
        // })
        // if(name == 'project' || name == 'authorization'){
        //     res = true
        // }
        // return res ? true : false
    }

    togglePermissions(permission: string) {
        this.$set(this.permissionVisibility, permission, !this.permissionVisibility[permission])
    }

    numPermissionsExSystem(group: string, permissions: string[]) {
        let relPermissions = permissions
            .filter((item) => item.includes(`${group}.`))
            .filter((item: string) => {
                let foundObject: any = null

                this.columns.forEach((permission) => {
                    if (
                        permission instanceof Permission &&
                        permission._id == item &&
                        !permission['isSystemPermission']
                    ) {
                        foundObject = permission
                    }
                })

                return foundObject
            })
        return relPermissions.length
    }
}
